import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { Bug, ChatSquareDots,  Key,  Unlock } from "react-bootstrap-icons";
import courseStyles from '../../styles/CourseDetail.module.css'
import Link from 'next/link'
import { cloudfront } from "../../config"

//imported in pages/course-details.js
export default function CourseStartCard() {
    return (
        <Card className="mx-1 mt-4 shadow-sm">
            <video height="220" controls loop>
                    <source className="card-img-top" src={`${cloudfront}/django_web_app/encore+sample+1.mp4`} alt="Building a Django Web App" />
            </video>
            <Card.Body>
                <div className={courseStyles.thumbnail_info}>
                    <p className={courseStyles.small}>Learn to build this easily customizable web app.</p>
                        <Link href="/build-a-django-web-app" passHref>
                            <a className="d-grid gap-2 mb-4 text-deco">
                                <Button variant="purple" size="lg">
                                        Get Started
                                </Button>
                            </a>
                        </Link>
                        {[
                            { key: 0, icon: <Unlock className="pr-2"/>, content: "All content unlocked from the start" },
                            { key: 1, icon: <ChatSquareDots className="pr-2"/>, content: "Ask questions in the commenting system" },
                            { key: 2, icon: <Bug className="pr-2"/>, content: "View list of common errors and solutions" },
                            { key: 3, icon: <Key className="pr-2"/>, content: "Unlimited access at no cost" }
                            ].map(({ key, icon, content }) => (
                            <p key={key}>
                               {icon} {content}
                            </p>
                        ))}    
                </div>
            </Card.Body> 
        </Card>
    )
}